import { ProWebUrl, OriginWebUrl, ActivityUrl } from '@/utils/dispatchEnv';

class Jsbridge {
  constructor () {
    this.version = '1.0.0';
    window['frame_android_uniqueId'] = 1;
    this.h5Url = ProWebUrl;
    this.originUrl = OriginWebUrl;
    this.activityUrl = ActivityUrl;
  }

  call (vMethodName, vParam, vCallback, vOptions) {
    if (!window.JSBridge && !window.webkit && !window.WebViewIOSJavascriptBridge) {
      return
    }
    let vCallbackName = '';
    if (vCallback) {
      window['frame_android_uniqueId']++
      vCallbackName = `cb_${window['frame_android_uniqueId']}_${new Date().getTime()}`;
      window[vCallbackName] = vCallback;
    }
    const strParams = vParam ? JSON.stringify(vParam) : ''
    try {
      if (window.JSBridge && window.JSBridge.AndroidMobileJSBridge) {
        window.JSBridge.AndroidMobileJSBridge(vMethodName, strParams, vCallbackName);
        return;
      } else if (window.WebViewIOSJavascriptBridge) {
        window.WebViewIOSJavascriptBridge(vMethodName, strParams, vCallbackName);
        return;
      } else if (!window.webkit) {
        return;
      }
      const param = {
        actionName: vMethodName,
        vCallbackName: vCallbackName || '',
        vParam: vParam || ''
      };
      if (!vParam && !vCallbackName) {
        delete param.vCallbackName
        delete param.vParam
      }
      window.webkit.messageHandlers.h5Action.postMessage(JSON.stringify(param));
    } catch (e) {
    }
  }
}

export default Jsbridge;



// WEBPACK FOOTER //
// ./src/starcharge/utils/jsbridge.js